import React, { FC } from "react";
import { styled } from "@mui/material/styles";
import { Cancel as CancelIcon, FileUpload as FileUploadIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { userState } from "../../../../states/userState";
import { useRecoilValue } from "recoil";
import {
  foreColorCode,
  foreColorCodeOnMouseOver,
} from "../../../../commons/colors";

type Props = {
  disabled: boolean;
  onClick: () => void;
  caption: string;
};
export const AllButton: FC<Props> = ({ disabled, onClick, caption }) => {
  const user = useRecoilValue(userState);
  const getStyles = () => {
    let styles = {
      backgroundColor: foreColorCode(user?.mode ?? "lite"),
      color: "#000",

      fontSize: 16,
      height: 30,
      // marginBottom: 16,
      width: 30,
      boxShadow: "3px 3px 8px 1px #202226",
      transition: "all 0.3s",
      "&:hover": {
        backgroundColor: foreColorCodeOnMouseOver(user?.mode ?? "lite"),
        color: "#37393F",
        boxShadow: "none",
        transform: "translate(3px, 3px)",
      },
    };
    return styles;
  };
  return (
    <IconButton
      component="label"
      disabled={disabled}
      onClick={onClick}
      sx={getStyles()}
    >
      <Tooltip title={caption} placement="right">
        <FileUploadIcon />
      </Tooltip>
    </IconButton>
  );
};
